import { SxProps } from '@mui/material';

export const PROFILE_ROOT_STYLES: SxProps = {
  '.profile-rule-summary': { flexGrow: 1 },
  '.profile-header': {
    p: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    '& .MuiTypography-root': {
      fontWeight: 500,
      fontSize: '0.875rem',
    },
  },
  '.border-bottom': {
    borderBottom: '1px solid',
    borderBottomColor: 'grey.300',
  },
  '.profile-row': {
    display: 'flex',
    flexDirection: 'row',
    px: 2,
    py: 1,
    alignItems: 'center',
  },
};
